import { render, staticRenderFns } from "./BtnLoginAD.vue?vue&type=template&id=60a68bba"
import script from "./BtnLoginAD.vue?vue&type=script&lang=js"
export * from "./BtnLoginAD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports